import { render, staticRenderFns } from "./PrintRelatorio.vue?vue&type=template&id=2b83999e&"
import script from "./PrintRelatorio.vue?vue&type=script&lang=js&"
export * from "./PrintRelatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports